import { gql } from '@/lib/graphql/gql'

export const APP_DISPLAY_NAME_QUERY = gql`
  query AppDisplayName($appName: String!) {
    app(name: $appName) {
      id
      source
      idCompany
      idProject
      name
      displayName
    }
  }
`

export const APP_PROCESSES_QUERY = gql`
  query AppProcesses($appName: String!) {
    app(name: $appName) {
      id
      displayName
      processes {
        id
        type
        displayName
      }
      cluster {
        id
        displayName
        location
      }
    }
  }
`
